/**
 * Responsibility: Implement modal motion behavior for the ui/helpers surface.
 * Scope: Owns ui/helpers concerns only; cross-surface orchestration is excluded.
 */

// Kept as a thin shared helper until every remaining dialog owner converges on one modal primitive.

const closingTimers = new WeakMap<HTMLDialogElement, number>()

function clearCloseTimer(dialog: HTMLDialogElement) {
  const existing = closingTimers.get(dialog)
  if (existing) {
    window.clearTimeout(existing)
    closingTimers.delete(dialog)
  }
}

export function openDialogWithMotion(dialog: HTMLDialogElement | null | undefined): boolean {
  if (!dialog) return false
  clearCloseTimer(dialog)
  dialog.classList.remove('is-closing')
  delete dialog.dataset.modalClosing
  dialog.inert = false
  dialog.style.pointerEvents = ''
  if (!dialog.open) dialog.showModal()
  return true
}

export function closeDialogWithMotion(
  dialog: HTMLDialogElement | null | undefined,
  durationMs = 170,
): boolean {
  if (!dialog?.open) return false
  if (dialog.dataset.modalClosing === '1') return true
  clearCloseTimer(dialog)
  dialog.dataset.modalClosing = '1'
  dialog.classList.add('is-closing')
  dialog.inert = true
  dialog.style.pointerEvents = 'none'
  const timer = window.setTimeout(() => {
    dialog.classList.remove('is-closing')
    delete dialog.dataset.modalClosing
    if (dialog.open) dialog.close()
    dialog.inert = false
    dialog.style.pointerEvents = ''
    closingTimers.delete(dialog)
  }, Math.max(0, Number(durationMs) || 0))
  closingTimers.set(dialog, timer)
  return true
}
